@if (propertyViewModel?.securityAccess == null) {
  @if (!multiselect) {
    <nts-base-enum-text-box
      #baseEnumTextBox
      (onChange)="onChange($event)"
      (onFinishEditing)="onFinishEditing.emit($event)"
      (onBlur)="onBlur()"
      [value]="value"
      [listenClickOutside]="listenClickOutside"
      [options$]="visibleValueDescriptions$"
      [errorList]="$safeNavigationMigration(propertyViewModel?.errors$) | async"
      [appendTo]="appendTo"
      [openDropdownOnUpDownArrowKey]="openDropdownOnUpDownArrowKey$ | async"
      [showErrorTooltip]="showErrorTooltip"
      [showErrorBorder]="showErrorBorder"
      [isNullable]="isNullable"
      [isDisabled]="isDisabled || !(propertyViewModel.isEnabled$ | async) || propertyViewModel?.securityAccess != null"
      [placeholder]="placeholder"
      [scrollElementClass]="scrollElementClass"
      [customCommandList]="customCommandList"
      [overlayOptions]="$safeNavigationMigration(options?.overlayOptions)"
      [title]="getTitle()"
      (viewReady)="viewReadyCheck()"
      optionLabel="description"
      dataKey="key">
    </nts-base-enum-text-box>
  }
  @if (multiselect) {
    <nts-base-select-chips-box
      #baseEnumTextBox
      (onValueChange)="onModelChange($event)"
      (onFinishEditing)="onFinishEditing.emit($event)"
      [value]="selectedChips"
      [options$]="chipsOptions?.optionsList?.length > 0 ? optionsListFromChipsOptions$ : visibleValueDescriptions$"
      optionValue="key"
      optionLabel="description"
      [tabIndex]="tabIndex"
      [appendTo]="appendTo"
      [multiline]="false"
      [placeholder]="placeholder"
      [customCommandList]="customCommandList"
      [listenClickOutside]="listenClickOutside"
      [errorList]="$safeNavigationMigration(propertyViewModel?.errors$) | async"
      [showErrorBorder]="showErrorBorder"
      [showErrorTooltip]="showErrorTooltip"
      [hoverBorderColor]="propertyViewModel.hoverColor"
      [activeBorderColor]="propertyViewModel.activeColor"
      [defaultBorderColor]="propertyViewModel.defaultColor"
      [isDisabled]="isDisabled || !propertyViewModel.isEnabled"
      [isReadonly]="isDisabled || !propertyViewModel.isEnabled"
      [attr.data-property-name]="propertyViewModel.propertyName">
    </nts-base-select-chips-box>
  }
} @else {
  <nts-base-security-text-box
    #baseSecurityTextBox
    [accessMode]="propertyViewModel.securityAccess"
    [value]="initialValue != null ? initialValue : propertyViewModel.formattedValue$ | async">
  </nts-base-security-text-box>
}


